import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IEmploymentStatus,
  IEmploymentStatusState,
} from "./employmentstatusModel";
import {
  createEmploymentStatus,
  deleteEmploymentStatus,
  employmentStatusActiveInactive,
  getAllActiveEmploymentStatus,
  getAllEmploymentStatus,
  getEmploymentStatusByID,
  updateEmploymentStatus,
} from "./services/employmentstatus.services";

const initialState: IEmploymentStatusState = {
  loading: false,
  formLoading: false,
  error: "",
  EmploymentStatusList: [],
  EmploymentStatusID: null,
  EmploymentStatusDetail: {
    Title: "",
    IsActive: 1,
  },
};

const employmentstatusSlice = createSlice({
  name: "employmentstatus",
  initialState,
  reducers: {
    clearEmploymentStatusDetails: (state) => {
      state.EmploymentStatusDetail = initialState.EmploymentStatusDetail;
    },
    setEmploymentStatusID: (state, action) => {
      state.EmploymentStatusID = action.payload;
    },
    clearEmploymentStatusID: (state) => {
      state.EmploymentStatusID = initialState.EmploymentStatusID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllEmploymentStatus.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllEmploymentStatus.fulfilled,
      (state, action: PayloadAction<IEmploymentStatus[]>) => {
        state.loading = false;
        state.EmploymentStatusList = action.payload || [];
      }
    );
    builder.addCase(getAllEmploymentStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.EmploymentStatusList = [];
    });
    builder.addCase(getAllActiveEmploymentStatus.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveEmploymentStatus.fulfilled,
      (state, action: PayloadAction<IEmploymentStatus[]>) => {
        state.loading = false;
        state.EmploymentStatusList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveEmploymentStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.EmploymentStatusList = [];
    });
    builder.addCase(createEmploymentStatus.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createEmploymentStatus.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createEmploymentStatus.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateEmploymentStatus.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateEmploymentStatus.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateEmploymentStatus.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteEmploymentStatus.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteEmploymentStatus.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteEmploymentStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(employmentStatusActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(employmentStatusActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(
      employmentStatusActiveInactive.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      }
    );
    builder.addCase(getEmploymentStatusByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getEmploymentStatusByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.EmploymentStatusDetail = action.payload;
    });
    builder.addCase(getEmploymentStatusByID.rejected, (state, action) => {
      state.formLoading = false;
      state.EmploymentStatusDetail = initialState.EmploymentStatusDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearEmploymentStatusDetails,
  setEmploymentStatusID,
  clearEmploymentStatusID,
} = employmentstatusSlice.actions;
export default employmentstatusSlice.reducer;
